import { Ref } from '@nuxtjs/composition-api';
import {
  IMotorcycleManualSearchSelection,
  IMotorcycleValidation,
  ISelectedOption,
  IVehicleSelection,
  IVehicleSelectionOption,
} from '@shared/types/IVehicleSelection';

import { FORM_FIELD_CONFIG } from '~/constants';

export const updateSelectedOptions = (
  selectedOptions: Ref<ISelectedOption[]>,
  selectedOption: ISelectedOption,
) => {
  if (selectedOptions.value.find(({ title }) => title === selectedOption.title)) {
    selectedOptions.value.forEach((option) => {
      if (option.title !== selectedOption.title) return;
      option.value = selectedOption.value;
    });
  } else {
    selectedOptions.value.push(selectedOption);
  }
};

export const clearFieldSelection = (selectedOptions: Ref<ISelectedOption[]>, fieldName: string) => {
  const index = selectedOptions.value?.findIndex(({ title }) => title === fieldName);
  if (index === -1) return;
  selectedOptions.value.splice(index, 1);
};

export const updateFormOptions = (
  formConfig: Ref<IVehicleSelection[]>,
  fieldTitle: string,
  options: IVehicleSelectionOption[],
) => {
  formConfig.value.forEach((fieldConfig) => {
    if (fieldConfig.title !== fieldTitle) return;
    fieldConfig.options = options;
    fieldConfig.isDisabled = !options?.length;
  });
};

export const validate = (
  validation: Ref<IMotorcycleValidation>,
  selectedOptions: Ref<ISelectedOption[]>,
): boolean =>
  FORM_FIELD_CONFIG.map((field: IVehicleSelection) => {
    if (
      !selectedOptions.value.find(({ title }) => title.toLowerCase() === field.title.toLowerCase())
    ) {
      validation.value[
        field.title.toLowerCase() as keyof IMotorcycleValidation
      ] = `Please select ${field.title}`;
      return false;
    }
    validation.value[field.title.toLowerCase() as keyof IMotorcycleValidation] = null;
    return true;
  }).every((valid: boolean) => valid);

export const toVehicleSelection = (
  selectedOptions: ISelectedOption[],
  isUsingSubmodel: boolean,
): IMotorcycleManualSearchSelection =>
  selectedOptions.reduce((accum, { title, value }) => {
    const key = title === 'Model' && isUsingSubmodel ? 'submodel' : title.toLowerCase();
    accum[key as keyof IMotorcycleManualSearchSelection] = value;
    return accum;
  }, {} as IMotorcycleManualSearchSelection);
